/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Toast } from '@hb/coffee';
import { RouterV2Enum } from '@/router/router-names';
import { Component, Vue } from 'vue-property-decorator';
import { insuranceUrl } from '@/constant';
import { openThirdPage } from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import type { MyProfileUnitItem } from '../../types';

import style from './index.module.scss';
import commonStyle from '../../index.module.scss';

@Component
export default class WelfareCenter extends Vue {
  private dataItems: MyProfileUnitItem[] = [
    // 由于保险业务，暂时下线邀请好友入口
    // {
    //   name: '邀请好友',
    //   tipsTitle: '邀请好友赚现金',
    //   image: require('./images/invite.png'),
    //   onClick: (_this: WelfareCenter) => _this.$router.push(RouterV2Enum.campaignShare),
    // },
    {
      name: '保险',
      threePartText: ['保障', '免费领', ' 理赔省心'],
      customClass: style.insuranceItem,
      onClick: () => {
        openThirdPage(insuranceUrl);
      },
    },
    {
      name: '优惠券',
      threePartText: ['参与', '返红包'],
      customClass: style.couponItem,
      onClick: ({ $router }: WelfareCenter) => $router.push(RouterV2Enum.myCoupon),
    },
  ];

  private render() {
    if (platform.isHarmony) {
      this.dataItems = [
        {
          name: '优惠券',
          threePartText: ['参与', '返红包'],
          customClass: style.couponItem,
          onClick: ({ $router }: WelfareCenter) => $router.push(RouterV2Enum.myCoupon),
        },
      ];
    }
    return (
      <div class={commonStyle.sectionContainer}>
        <div class={commonStyle.header}>福利中心</div>
        <ul class={[style.welfareListCenter]}>
          {this.dataItems.map((item) => (
            <li
              key={item.name}
              onClick={this.onClick.bind(this, item)}
              class={[style.welfareLi, item.customClass]}
            >
              <p class={style.name}>{item.name}</p>
              <p class={style.tipsText}>
                {item.threePartText?.map((text, index) => (
                  <span class={index === 1 && style.highlight}>{text}</span>
                ))}
              </p>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  private onCopy(email: string) {
    const oInput = document.createElement('input');

    oInput.value = email;
    oInput.style.position = 'absolute';
    oInput.style.left = '-100vw';

    document.body.appendChild(oInput);

    oInput.select();
    document.execCommand('Copy');
    document.body.removeChild(oInput);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    Toast('复制成功');
  }

  private onClick(item: MyProfileUnitItem) {
    this.$ubtPageButton(
      'finance_onMyProfileWelfareClick',
      'welfareName',
      item.name,
    );
    item.onClick(this);
  }
}
